import ProfilePic from "../sidebar/ProfilePic";
import Sidebar from "../sidebar/Sidebar";
import AddCampaigns from "../dashboard/AddCampaigns";

const ApplyCampaigns = ({ onLogout }) => {
  return (
    <div className="home_main">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="dashboard_main">
            <div className="dashboard_header">
              <h4>Apply Campaigns</h4>
              <div className="logout_box">
                <ProfilePic onLogout={onLogout} />
              </div>
            </div>
            <div className="container">
              <div className="camp_influencers_main mt-4">
                <AddCampaigns />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyCampaigns;
